import { Pipe, PipeTransform } from '@angular/core';
import {Item} from "../../models/Item";
import {ConcreteHierarchyItemInterface} from "../concreteLayers/ConcreteHierarchyItemInterface";

@Pipe({ name: 'groupByGroup' })
export class GroupByPipe implements PipeTransform {

  transform(itemsArr: any[] | null):{[key: string]: ConcreteHierarchyItemInterface[]} {
    if (!itemsArr){
      return {};
    }
    let resultObject:{[key: string]: ConcreteHierarchyItemInterface[]} = {};

    for (let item of itemsArr){
      if (item instanceof Item){

        if (!resultObject.hasOwnProperty(item.getGroup())){
          resultObject[item.getGroup()] = [];
        }
        resultObject[item.getGroup()].push(item);
      }
      else {
        if (!resultObject['-1']){
          resultObject['-1'] = [];
        }
        resultObject['-1'].push(item)
      }
    }

    return resultObject;
  }
}
